import { Box } from '@chakra-ui/react/box';
import { forwardRef, LegacyRef } from 'react';

const TooltipPortal = forwardRef((_props, ref) => (
  <Box
    width="100%"
    position="sticky"
    top="0"
    overflow="visible"
    zIndex="5500"
    transform="translateZ(0)"
    ref={ref as LegacyRef<HTMLDivElement>}
  />
));
TooltipPortal.displayName = 'TooltipPortal';

export default TooltipPortal;
